<template>
  <div class="meet9ingnotice">
    <Header :title="$t('m.PersonProfile')"></Header>
    <div class="tab" v-if="tab">
      <div style="height:1rem;text-align:center">
        <img :src="usermessage.image" alt style="height:1rem;width:1rem;border-radius:50%" />
      </div>
      <div class="row">
        <div class="left">{{$t('m.NameColon')}}</div>
        {{usermessage.name}}
      </div>
      <div class="row">
        <div class="left">{{$t('m.UnitColon')}}</div>
        {{usermessage.department}}
      </div>
      <div class="row">
        <div class="left">{{$t('m.MobileColon')}}</div>
        {{usermessage.mobile}}
      </div>
      <div class="row">
        <div class="left">{{$t('m.EMailColon')}}</div>
        {{usermessage.email}}
      </div>
      <div @click="tab=!tab" class="button bgc">{{$t('m.Edit')}}</div>
    </div>
    <div class="tab" v-if="!tab">
      <div style="height:1rem;text-align:center;border:1px solid #ddd;border-radius:10px">
        <div v-if="uploadshow" @click="uploadshow=!uploadshow">
          <img
            alt
            style="height:1rem;width:1rem;border-radius:50%"
            :src="usermessage.image?usermessage.image:unLineimg"
          />
        </div>

        <Upload
          :before-upload="uploadstart"
          :format="['jpg','jpeg','png','bmp']"
          :on-success="uploads"
          :show-upload-list="false"
          @on-error="uploaderr"
          accept="image/*"
          :action="picUrl"
          name="uploadPic"
          type="drag"
          v-else
        >
          <div style="padding:5px 0;height:1rem; width:100%;line-height:0.2rem">
            <Icon size="40" style="color: #3399ff" type="ios-cloud-upload"></Icon>
            <br />
            <span class="color">{{$t('m.PlsClickSelectMobilePicture')}}</span>
            <br />
            <span class="color">{{$t('m.SelectCamoraOrSelectPicture')}}</span>
          </div>
        </Upload>
      </div>
      <div class="row">
        <div class="left">{{$t('m.NameColon')}}</div>
        <input type="text" v-model="usermessage.name" disabled />
      </div>
      <div class="row">
        <div class="left">{{$t('m.UnitColon')}}</div>
        <input type="text" v-model="usermessage.department" disabled />
      </div>
      <div class="row">
        <div class="left">{{$t('m.MobileColon')}}</div>
        <input type="text" v-model="usermessage.mobile" />
      </div>
      <div class="row">
        <div class="left">{{$t('m.EMailColon')}}</div>
        <input type="text" v-model="usermessage.email" />
      </div>
      <div @click="editusermessage()" class="button1 bgc">{{$t('m.SaveSpace')}}</div>
      <div @click="tab=!tab" class="button2 bgc">{{$t('m.CancelBtn')}}</div>
    </div>
  </div>
</template>
<script>
import Header from "../header/header";
import { editusermessage, usermessage } from "../../assets/js/url";

export default {
  name: "usermessage",
  data() {
    return {
      unLineimg: require("../../../static/img/1.png"),
      picUrl: `/api/user/addpic/${window.sessionStorage.getItem("UUID")}`,
      usermessage: {
        image: "",
        name: "",
        department: "",
        mobile: "",
        email: ""
      },
      tab: true,
      uploadshow: true,
      imageurl: ""
    };
  },
  components: {
    Header
  },
  activated() {
    this.tab = true;
    this.getusermessage();
  },
  methods: {
    isPoneAvailable(pone) {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(pone)) {
        return false;
      } else {
        return true;
      }
    },
    isEmailAvailable(emailInput) {
      var myreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (!myreg.test(emailInput)) {
        return false;
      } else {
        return true;
      }
    },
    uploadstart() {
      this.$loadingshow();
    },
    uploads(res) {
      this.$loadingclose();
      this.$toast(this.$t('m.UploadOK'));
      this.usermessage.image = res.data.localpicpath.replace(
        /[a-z\/]*static/,
        "./static/"
      );
      this.uploadshow = true;
    },
    uploaderr(res) {
      this.$loadingclose();
      this.$toast(this.$t('m.UploadFailSendAgain'));
    },
    // overSize() {
    //   this.$loadingclose();
    //   this.$toast("图片大小须小于45KB");
    // },
    getusermessage() {
      this.$http
        .post(usermessage, {
          useruuid: window.sessionStorage.getItem("UUID"),
          usertype: 2
        })
        .then(res => {
          this.usermessage = res.data.data;
          this.uploadshow = this.usermessage.image || "";
        });
    },
    editusermessage() {
      if (
        this.isPoneAvailable(this.usermessage.mobile) &&
        this.isEmailAvailable(this.usermessage.email)
      ) {
        this.$http.post(editusermessage, this.usermessage).then(res => {
          this.$toast(this.$t('m.SaveOK'));
          this.uploadshow = true;
          this.tab = !this.tab;
        });
      } else {
        this.$Message.warning(this.$t('m.PlsEnterRightMobileEMail'));
      }
    }
  }
};
</script>
<style scoped>
.meet9ingnotice {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.2rem;
  font-size: 0.14rem;
  line-height: 0.49rem;
}

.row {
  height: 0.49rem;
  border-bottom: 1px solid #d7d5d5;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.left {
  float: left;
  width: 0.5rem;
  text-align: center;
}

.warp {
  height: 2.37rem;
  padding: 0.1rem 0;
  text-align: center;
}

.content {
  line-height: 0.28rem;
  width: 1.7rem;
  float: left;
}

.button {
  width: 100%;
  height: 0.41rem;
  margin-top: 0.07rem;
  color: #fff;
  text-align: center;
  font-size: 0.15rem;
  border-radius: 3px;
  line-height: 0.41rem;
  float: right;
}

.button1 {
  width: 45%;
  height: 0.41rem;
  margin-top: 0.07rem;
  color: #fff;
  text-align: center;
  font-size: 0.15rem;
  border-radius: 3px;
  line-height: 0.41rem;
  float: left;
}

.button2 {
  width: 45%;
  height: 0.41rem;
  margin-top: 0.07rem;
  color: #fff;
  text-align: center;
  font-size: 0.15rem;
  border-radius: 3px;
  line-height: 0.41rem;
  float: right;
}

input {
  width: 2.5rem;
  border: none;
  background-color: transparent;
  height: 0.35rem;
  outline: none;
  vertical-align: middle;
  line-height: 0.35rem;
}

.tab {
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/content/usermessage.vue